__turbopack_context__.v({
  "description": "PromotionTerms-module-scss-module__c_uk8W__description",
  "promotionTerms": "PromotionTerms-module-scss-module__c_uk8W__promotionTerms",
});
